import React, {useEffect, useState} from "react";
import "./BestPlans.scss";
import moreDetailArrow from "../../../assets/ProductPageIcons/more_detail_Arrow.svg";
import {dollarUS} from "../../../utils/helpers/string";

const BestPlans = ({challenges, onMoreDetails, onBuyPreset}) => {
  const planeOne = challenges["Alpha Pro"]?.[4];

  const planeTwo = challenges["Alpha One"]?.[3];
  const planeThree = challenges["Swing"]?.[4];

  console.log("challenges", planeOne);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="bestPlans_wrapper">
        <div className="bestPlans_header">
          <div className="bestPlans_header_inner">
            <h4>Product</h4>
            <h2>
              Still Not Sure? <span>Check Out Our Popular Presets</span>
            </h2>
            <p>Best setting based of choices by Alpha Trader</p>
          </div>
        </div>
        <div className="plans_container">
          <div
            className="plans_one"
            id="plan"
          >
            <h3>Alpha {planeThree?.plan_type}</h3>
            <h4>
              Price: <span>{dollarUS(planeThree?.Price || 0)}</span>
            </h4>
            <div className="plan_mid">
              <h3>{planeThree?.name?.match(/\d+/)?.[0]}k</h3>
              <div className="planTags">
                <p>Alpha {planeThree?.plan_type} Account</p>
              </div>
              <p>2-Step evaluation</p>
            </div>
            <div className="line"></div>
            <div className="plan_lower">
              <div>
                <p>Balance</p>
                <p>{dollarUS(planeThree?.account_balance)}</p>
              </div>
              <div>
                <p>Max Sim Drawdown</p>
                <p>10.00%</p>
              </div>
              <div>
                <p>Analyst Performance Fee</p>
                <p>80%</p>
              </div>
              <button
                className="more_details_btn"
                onClick={() => onMoreDetails(planeThree?.id)}
              >
                More Details{" "}
                <img
                  src={moreDetailArrow}
                  alt="moreDetailArrow"
                />
              </button>
            </div>
            <button
              className="but_preset_btn"
              onClick={() => onBuyPreset(planeThree?.id)}
            >
              Buy Preset
            </button>
          </div>
          <div
            className="plans_second"
            id="plan"
          >
            <h3>{planeTwo?.plan_type}</h3>
            <h4>
              Price: <span>{dollarUS(planeTwo?.Price || 0)}</span>
            </h4>
            <div className="plan_mid">
              <h3>{planeTwo?.name?.match(/\d+/)?.[0]}k</h3>
              <div className="planTags">
                <p>{planeTwo?.plan_type} Account</p>
              </div>
              <p>1-Step evaluation</p>
            </div>
            <div className="line"></div>

            <div className="plan_lower">
              <div>
                <p>Balance</p>
                <p>{dollarUS(planeTwo?.account_balance)}</p>
              </div>
              <div>
                <p>Max Sim Drawdown</p>
                <p>6.00%</p>
              </div>
              <div>
                <p>Analyst Performance Fee</p>
                <p>80%</p>
              </div>
              <button
                className="more_details_btn"
                onClick={() => onMoreDetails(planeTwo?.id)}
              >
                More Details{" "}
                <img
                  src={moreDetailArrow}
                  alt="moreDetailArrow"
                />
              </button>
            </div>
            <button
              className="but_preset_btn"
              onClick={() => onBuyPreset(planeTwo?.id)}
            >
              Buy Preset
            </button>
          </div>
          <div
            className="plans_third"
            id="plan"
          >
            <h3>{planeOne?.plan_type}</h3>
            <h4>
              Price: <span>{dollarUS(planeOne?.price_alpha_pro_10per || 0)}</span>
            </h4>{" "}
            <div className="plan_mid">
              <h3>{planeOne?.name?.match(/\d+/)?.[0]}k</h3>
              <div className="planTags">
                <p>{planeOne?.plan_type} Account</p>
              </div>
              <p>2-Step evaluation</p>
            </div>
            <div className="line_three"></div>
            <div className="plan_lower">
              <div>
                <p>Balance</p>
                <p>{dollarUS(planeOne?.account_balance || 0)}</p>
              </div>
              <div>
                <p>Max Sim Drawdown</p>
                <p>10.00%</p>
              </div>
              <div>
                <p>Analyst Performance Fee</p>
                <p>80%</p>
              </div>
              <button
                className="more_details_btn"
                onClick={() => onMoreDetails(planeOne?.id)}
              >
                More Details{" "}
                {/* <img
                  src={moreDetailArrow}
                  alt="moreDetailArrow"
                /> */}
              </button>
            </div>
            <button
              className="but_preset_btn"
              onClick={() => onBuyPreset(planeOne?.id)}
            >
              Buy Preset
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BestPlans;
